import React, { useState, useEffect } from "react"
import { FilterConditionsHandler } from "../Utils/filter_conditions_handler"

export const AreaContext = React.createContext([])
export const CategoryContext = React.createContext([])
const handler = new FilterConditionsHandler()

const fetchAreas = async (setAreas: Function) => {
  const areas = await handler.fetchAreas()
  setAreas(areas)
}

const fetchCategories = async (setCategories: Function) => {
  const categories = await handler.fetchCategories()
  setCategories(categories)
}

export const FilterConditionsRoot = (props) => {
  const [areas, setAreas] = useState([])
  const [categories, setCategories] = useState([])

  useEffect(() => {
    let mounted = true
    const code = async () => {
      if (mounted) {
        await fetchAreas(setAreas)
        await fetchCategories(setCategories)
      }
    }
    code()
    return () => {
      mounted = false
    }
  }, [])

  return (
    <AreaContext.Provider value={areas}>
      <CategoryContext.Provider value={categories}>
        {props.children}
      </CategoryContext.Provider>
    </AreaContext.Provider>
  )
}
